import DocumentItemsModule from '~/lib/vue/modules/document/items';

export default (services, namespace='terms') => {
  return DocumentItemsModule.create({
    defaultItem: {
      text: '', 
    },
  });
};
